import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

import SmartDisplayIcon from "@mui/icons-material/SmartDisplay"
import AutoRenewIcon from "@mui/icons-material/Autorenew"
import { SitemarkIcon } from './CustomIcons';
import AIBlogBlue from "../Assets/AIBlog.png"


const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Effortless content creation',
    description:
      'Transform your videos into engaging blog content with ease, streamlinig your workflow and saving time.',
  },
  {
    icon: <ConstructionRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Built for creators',
    description:
      'Leverage the power of AI to generate high-quality blog posts, ensuring long-lasting value for your content needs.',
  },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Great user experience',
    description:
      'Our intuitive platform makes content creation simple, enabling you to focus on your creativity without technical hassle.',
  },
  {
    icon: <AutoFixHighRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Cutting-edge AI technology',
    description:
      'Stay ahead in content creation with innovative AI features that turn videos into well-crafted blog posts tailored to your audience.',
  },
  {
    icon: <SmartDisplayIcon sx={{ color: 'text.secondary' }} />,
    title: 'Smart video to blog conversion',
    description:
      'Turn your video insights into comprehensive blogs in seconds, powered by advanced AI algorithms.',
  },
  // {
  //   icon: <AutoRenewIcon sx={{ color: 'text.secondary' }} />,
  //   title: 'Efficient Workflow Integration',
  //   description:
  //     'Incorporate our tool seamlessly into your existing content creation process, enhancing productivity without disruption.',
  // },
];

export default function Content() {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
    >
      <Box sx={{ display: { md: 'flex' } }}>     {/*xs: 'none',*/}
        {/* <SitemarkIcon />  */}
        <img src={AIBlogBlue} style={{width: "155px", padding:0,marginTop:-6}} /> 

      </Box>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}
